<template>
    <div>
        <b-navbar :transparent="true" class="mb-5" :close-on-click="false">
            <template #brand>
                    <img :src="logoUrl" alt="iys logo">
            </template>

            <template #end>
                <b-navbar-item>
                    <b-dropdown
                    position="is-bottom-left"
                    append-to-body
                    aria-role="menu"
                    trap-focus
                    v-model="$i18n.locale"
                    >
                        <template #trigger>
                            <a
                                class="navbar-item"
                                role="button">
                                
                                <b-icon icon="earth"></b-icon>
                                {{$t('lang_'+$i18n.locale)}}
                                <b-icon icon="menu-down"></b-icon>
                            </a>
                        </template>

                        <b-dropdown-item aria-role="listitem" v-for="lang in langs" :key="lang.value" :value="lang.value" @click="changeLang(lang.value)">{{lang.label}}</b-dropdown-item>
                        
                    </b-dropdown>
                </b-navbar-item>
            </template>
        </b-navbar>
    </div>
</template>
<script>
export default {
    name:"LoginHeader",
    data() {
        return {
            langs : [{"value":"tr","label":this.$t('lang_tr')},{"value":"en","label":this.$t('lang_en')}],
            logoUrl: "/static/images/Logo.svg",
        }
    },
    methods: {
        changeLang(val){
            localStorage.setItem('lang',val)
            this.$moment.locale(val)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginHeader.vue